import {SiteConfigurations} from "@/hooks/custom/helpcenter.hooks";

// ---------------------------------------------------------------------

/**
 * 条件によって初期設定を行うヘルパー関数
 * この関数は、サイト設定に基づいてヘルプセンターの拡張機能の設定を取得します。
 * @param siteConfig - サイト設定オブジェクト
 * @returns 拡張機能の設定オブジェクト
 */
export function getExtensionsSetting(siteConfig: SiteConfigurations) {

  return {
    service_name: siteConfig?.service_name ?? '',  // ここからが拡張
    footer_text: siteConfig?.footer_text ?? '',
    category_text:siteConfig?.category_text ?? 'カテゴリ一覧',
    search_placeholder:siteConfig?.search_placeholder ?? 'ここに質問を入力',
    disallow_email: siteConfig?.disallow_email ?? false,
    disallow_number: siteConfig?.disallow_number ?? false,
    disallow_longtext: siteConfig?.disallow_longtext ?? true,
    disallow_prefecture: siteConfig?.disallow_prefecture ?? false,
    tag_title: siteConfig?.tag_title ?? 'タグの提案',
    tag_show_limit: siteConfig?.tag_show_limit ?? 20,
    no_qa_result_message:siteConfig?.no_qa_result_message ?? '該当するタグは見つかりませんでした',
    no_result_title:siteConfig?.no_result_title ?? '検索条件に一致する結果が見つかりませんでした',
    no_result_message:siteConfig?.no_result_message ?? '誤字脱字をチェックするか、単語ベースで再検索してみてください。',
    retry_label:siteConfig?.retry_label ?? '検索結果へ戻る',
    referer_label:siteConfig?.referer_label ?? '前のページに戻る',
    reset_label:siteConfig?.reset_label ?? '最初から',
    tag_select_title:siteConfig?.tag_select_title ?? 'よく使われるタグ',
    qa_list_title:siteConfig?.qa_list_title ?? 'よくいただくご質問',
    show_qid:siteConfig?.show_qid ?? true,
    qa_answer_title:siteConfig?.qa_answer_title ?? '回答',
    article_list_title:siteConfig?.article_list_title ?? 'ヘルプ記事',
    article_list_link_text:siteConfig?.article_list_link_text ?? '一覧',
    show_aid:siteConfig?.show_aid ?? true,
    view_history_title:siteConfig?.view_history_title ?? '最近ご覧になったページ',
    feedback_title:siteConfig?.feedback_title ?? 'お役に立ちましたか？',
    yes_label:siteConfig?.yes_label ?? 'はい',
    no_label:siteConfig?.no_label ?? 'いいえ',
    yes_message:siteConfig?.yes_message ?? `ありがとうございます。

    何かご意見などありましたら教えてください。`,
    no_message:siteConfig?.no_message ?? `お役に立てず申し訳ありません。

    よろしければ理由を選択してください。`,
    no_reason_accuracy_label:siteConfig?.no_reason_accuracy_label ?? '知りたいことと違った',
    no_reason_contents_label:siteConfig?.no_reason_contents_label ?? '分かりにくかった',
    no_reason_answer:siteConfig?.no_reason_answer ?? 'その他の理由の場合はご記入ください。',
    comment_placeholder:siteConfig?.comment_placeholder ?? 'ご自由にご記入ください。',
    comment_submit_label:siteConfig?.comment_submit_label ?? '送信',
    comment_message:siteConfig?.comment_message ?? `ご回答ありがとうございました。

    コンテンツの改善の参考にさせていただきます。`,
  }
}
